<script setup lang="ts">
const props = defineProps({
  value: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    required: false,
    default: '',
  },
})
const emit = defineEmits(['update:value'])
const value = computed({
  get() {
    return props.value
  },
  set(value) {
    emit('update:value', value)
  },
})
</script>
<template>
  <span class="p-input-icon-left lg:w-4">
    <i class="pi pi-search py-0 px-2" />
    <InputText
      v-model="value"
      type="text"
      class="p-inputtext-lg w-full input-search"
      :placeholder="props.placeholder"
    />
  </span>
</template>
<style lang="scss" scoped>
.input-search {
  border-radius: 3rem;
}
</style>
